import { Button, ButtonVariant, Modal, Typography } from '@/shared/ui';

type AddressWarningModalProps = {
  isModalOpen: boolean;
  closeModal: () => void;
};

export const AddressWarningModal: React.FC<AddressWarningModalProps> = ({ isModalOpen, closeModal }) => {
  return (
    <Modal
      open={isModalOpen}
      size="md"
      centered
      title="Подальше створення заяви неможливе"
      onCancel={closeModal}
      maskClosable={false}
      footer={
        <Button onClick={closeModal} variant={ButtonVariant.PRIMARY}>
          Зрозуміло
        </Button>
      }
    >
      <Typography as="p">
        Нове місце зберігання зброї співпадає з поточним.
        <br />
        Перевірте адресу нового місця зберігання зброї.
      </Typography>
    </Modal>
  );
};
